module.exports = __webpack_public_path__ + "img/inactive-publisj.cc79c056.svg";